import React from 'react';

import { Stat } from '../types';
import Statistics from './Statistics';

interface SubscriberMetricsProps {
  activeSubscribers: Stat;
  proUpgradeUserRequests: Stat;
}

const SubscriberMetrics = ({
  activeSubscribers,
  proUpgradeUserRequests,
}: SubscriberMetricsProps) => {
  if (activeSubscribers.value === 0 && proUpgradeUserRequests.value === 0) {
    return null;
  }

  return (
    <section className="mt-28 flex items-stretch gap-20">
      {activeSubscribers.value > 0 && <Statistics {...activeSubscribers} />}
      {proUpgradeUserRequests.value > 0 && <Statistics {...proUpgradeUserRequests} />}
    </section>
  );
};

export default SubscriberMetrics;
